export interface StructuredAddress {
  line1: string;
  line2: string;
  city: string;
  stateRegion: string;
  postalCode: string;
  country: string;
}

export function emptyStructuredAddress(): StructuredAddress {
  return {
    line1: '',
    line2: '',
    city: '',
    stateRegion: '',
    postalCode: '',
    country: ''
  };
}

/** Builds a multi-line string for API storage (unchanged contract). */
export function formatStructuredAddressForStorage(a: StructuredAddress): string {
  const cityLine = [a.city, a.stateRegion, a.postalCode].map((s) => s.trim()).filter(Boolean).join(', ');
  const lines = [a.line1.trim(), a.line2.trim(), cityLine, a.country.trim()].filter((s) => s.length > 0);
  return lines.join('\n');
}

export function isStructuredAddressComplete(a: StructuredAddress): boolean {
  return (
    !!a.line1.trim() &&
    !!a.city.trim() &&
    !!a.stateRegion.trim() &&
    !!a.postalCode.trim() &&
    !!a.country.trim()
  );
}
